<template>
  <div>
    <q-dialog
      :visible="isVisible"
      :title="title"
      width="1150px"
      :innerScroll="false"
      :loading="loadingButtom"
      :showFooter="false"
      @close="onCancel"
    >
        <div style="width:100%;height:342px" v-show="isShowDiv"></div>
        <div ref="editor"></div>
    </q-dialog>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close
      ><imgShow :imgList="imgList"></imgShow
    ></el-dialog>
  </div>
</template>

<script>
import E from "wangeditor";
import imgShow from "@/views/components/imgShow";
import { getToken } from "@/utils/auth";
export default {
  components: { imgShow },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    appealReason: String,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "申诉理由";
    },
    userName() {
      return this.$store.state.user.name;
    },
  },
  data() {
    return {
      loadingButtom: false,
      imgFormVisible: false,
      imgList: [],
      htmlImgList: [],
      isShowDiv: true
    };
  },
  mounted() {
    setTimeout(() => {
      let editor = new E(this.$refs.editor);
      editor.config.menus = [
      ];
      editor.config.placeholder = "";
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; // 将图片大小限制为 10M
      editor.config.uploadFileName = "file"; //后端接受上传文件的参数名
      editor.config.uploadImgMaxLength = 1; // 限制一次最多上传 1 张图片
      editor.config.uploadVideoAccept = ["jpg", "jpeg", "png", "gif", "bmp"];
      editor.config.showLinkImg = false; //隐藏网络图片上传
      editor.config.maxLength = 500; //最大输入

      editor.config.uploadImgHeaders = {
        "Access-Control-Allow-Origin": "origin",
        Authorization: getToken,
      };
      editor.txt.eventHooks.imgClickEvents.push(this.imgClick);
      editor.create();
      editor.$textElem.attr('contenteditable', false)  //禁用
      if (this.appealReason) {
        let htmlText = this.appealReason;
        editor.txt.html(htmlText);
      }
      this.isShowDiv = false
    }, 500);
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    imgClick(e) {
      let img = e.elems[0].currentSrc;
      this.imgFormVisible = true;
      this.imgList = [img];
    },

  },
};
</script>

<style lang="stylus" scoped>

>>> .el-dialog__body {
  max-height: 70vh
  overflow-y: auto
  overflow-x: hidden
}

>>> .el-dialog {
  margin: 50px auto !important
}

</style>
